import React from 'react'
import { AppContext, Level } from '../contexts/AppContext'
import { shuffle, labsAPI } from '@elgatoylacaja/utils'

const getPrevForLevel = async (level: Level, fork: string) => {
  const defaultOthers = {
    other_color: Math.ceil((Math.random() * 10) % 2).toString() as '1' | '2',
    other_probabilidad:
      fork === 'numeros-numeros-numeros'
        ? Math.floor(Math.random() * 51 + 50)
        : shuffle([1, 2, 4, 6, 8, 9, 10, 11])[0],
    random: true,
    timestamps: {
      color: [],
      probabilidad: [],
    },
  }

  return (await labsAPI
    .getPrevValues({
      key: `${level.level_key}_color_probabilidad_fork`,
      qty: 10,
    })
    .then(res => {
      const prev: string | undefined = res.data.find(x => x.includes(fork))
      if (prev !== undefined) {
        const [color, probabilidad] = prev.split(',')
        return {
          ...level,
          others_form: {
            other_color: color as '1' | '2',
            other_probabilidad: parseInt(probabilidad),
            random: false,
            timestamps: {
              color: [],
              probabilidad: [],
            },
          },
        }
      } else {
        return {
          ...level,
          others_form: defaultOthers,
        }
      }
    })
    .catch(() => {
      return {
        ...level,
        others_form: defaultOthers,
      }
    })) as Level
}

const LazyPrevAnswers = () => {
  const { appState, dispatch } = React.useContext(AppContext)

  React.useEffect(() => {
    const {
      experiment: { fork_etapa_3, etapa_3 },
    } = appState
    Promise.all(
      etapa_3.plays.map(level => getPrevForLevel(level, fork_etapa_3))
    ).then(plays => {
      dispatch({
        type: 'SAVE_PREV_ANSWERS',
        plays,
      })
    })
  }, [])

  return <></>
}

export default LazyPrevAnswers
